import CartModalController from "emun.cart/cart-modal.controller.es6";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import resolve from "ioc/resolve";

export default class CartPickerController extends CartModalController {
  constructor($session, $cart, $uibModalInstance, options) {
    "ngInject";
    super($session, $cart, $uibModalInstance, options);

    this.db = new AutoQuery({
      url:
        "BrowseCarts.json?" +
        ($session.isSalesManagementMode()
          ? "StatusNotEqualTo=Quote"
          : "Status=Cart") +
        ($session.isRetailer() ? "&RetailerUser=" + $session.email : ""),
      autoLoad: true,
      pageSize: 20,
      orderBy: "-CreatedOn",
      append: true,
      sortOptions: {
        Id: "Order Number: Low to High",
        "-Id": "Order Number: High to Low",
        CartName: "Cart Name: A to Z",
        "-CartName": "Cart Name: Z to A",
        Status: "Status: A to Z",
        "-Status": "Status: Z to A",
        OrderedOn: "Order Date: Newest",
        "-OrderedOn": "Order Date: Oldest",
        GrandTotal: "Amount: Low to High",
        "-GrandTotal": "Amount: High to Low",
      },
    });
    resolve("$rootScope").$on("cartRemoved", () => this.db.load(true));

  }

  export(c) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "SalesOrderLinesExport?OrderNumber=" + c.id
    );
    return (location.href = url);
  }

  select(cart) {
    let $ctrl = this;
    $ctrl.$close(cart);
  }
}
